export const isBrowserFileUrl = (fileUrl) =>
  typeof fileUrl === 'string' &&
  (fileUrl.startsWith('blob:') || fileUrl.startsWith('data:'))

export const collectImageFilesFromSurvey = (survey) => {
  const files = {}
  ;(survey?.questions || []).forEach((question) => {
    if (!question?.imageFiles) return
    Object.keys(question.imageFiles).forEach((fileName) => {
      if (fileName) files[fileName] = question.imageFiles[fileName]
    })
  })
  return files
}

export const getPhotoFilenamesFromSurvey = (survey) =>
  (survey?.questions || [])
    .filter((question) => question?.type === 'image_capture')
    .flatMap((question) =>
      (question?.answer || []).map((item) => item?.value).filter(Boolean),
    )

export const stripClientOnlyImageFields = (surveyJson) => {
  if (!surveyJson?.questions) return surveyJson
  return {
    ...surveyJson,
    questions: surveyJson.questions.map((question) => {
      if (!question || typeof question !== 'object') return question
      const { imageFiles, ...rest } = question
      return rest
    }),
  }
}

export const isPersistableImageUrl = (url) =>
  typeof url === 'string' &&
  (url.startsWith('data:image') || url.startsWith('blob:'))

export const restoreImageCaptureState = (props, minSlots = 3) => {
  const { id, storedAnswer, storedInstrument, submissionSurvey } = props || {}
  const fromSubmission = submissionSurvey?.questions?.find(
    (question) => question.id === id,
  )
  const fromStored = storedInstrument?.questions?.find(
    (question) => question.id === id,
  )
  const stored = {
    answer: storedAnswer || fromSubmission?.answer || fromStored?.answer || [],
    imageFiles: {
      ...(fromStored?.imageFiles || {}),
      ...(fromSubmission?.imageFiles || {}),
    },
    timeAnswered:
      fromSubmission?.time_answered || fromStored?.time_answered || null,
  }
  const captures = {}
  const restoredNames = []
  ;(stored.answer || []).forEach((item) => {
    const fileName = item?.value
    const fileUrl = stored.imageFiles?.[fileName]
    if (!fileName || !isPersistableImageUrl(fileUrl)) return
    restoredNames.push(fileName)
    captures[fileName] = fileUrl
  })
  const images = restoredNames.slice()
  while (images.length < minSlots) images.push(null)
  return {
    images,
    captures,
    timeAnswered: restoredNames.length ? stored.timeAnswered : null,
  }
}
